import { render, staticRenderFns } from "./LiquorLicenseFields.vue?vue&type=template&id=6c8e7b94"
import script from "./LiquorLicenseFields.vue?vue&type=script&lang=ts"
export * from "./LiquorLicenseFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports